// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TemplatesPopUp_wrapper__22w_W","checkboxMargin":"TemplatesPopUp_checkboxMargin__2aGNC","buttonMargin":"TemplatesPopUp_buttonMargin__3DUAh"};